import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { AnimatedItem } from '../../components/animation/AnimatedItem';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import Spinner from '../../components/common/Spinner';
import { Button, Flexed, PageTitle } from '../../styles/GlobalComponents';
import { HubLengthMessage } from '../../styles/stylesStyled';
import { InvoiceHeader, Invoices } from '../Accounting/AccountingStyled';
import { getWebinarsMenagement } from '../../slices/webinars-slice';
import CreateWebinar from './CreateWebinar';
import EditWebinar from './EditWebinar';
import SoldTickets from './SoldTickets';

export const WebinarsMenagnemt = () => {
  const [isSideModalOpen, setIsSideModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTicketsModalOpen, setIsTicketsModalOpen] = useState(false);
  const [selectedWebinar, setSelectedWebinar] = useState<any>(null);

  const dispatch = useDispatch();

  const isJoinButtonEnabled = (item: any) => {
    const now = new Date();

    const startTime = new Date(item.dateStart);

    const enableTime = new Date(startTime.getTime() - 15 * 60 * 1000);
    const endTime = new Date(startTime.getTime() + 45 * 60 * 1000);

    return now >= enableTime && now <= endTime;
  };

  useEffect(() => {
    dispatch(getWebinarsMenagement());
  }, [dispatch]);

  const { loading, webinarsMenagement } = useAppSelector(
    (state) => state.webinars
  );

  if (loading && !webinarsMenagement) {
    return <Spinner fullScreen />;
  }

  return (
    <AnimatedDashboard zoom>
      <Flexed between center>
        <PageTitle> Webinars Menagement</PageTitle>
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => setIsSideModalOpen(!isSideModalOpen)}>
          Create Webinar
        </div>
      </Flexed>

      <InvoiceHeader>
        <div style={{ width: '10%' }}>Name</div>
        <div style={{ width: '10%' }}>Date Created</div>
        <div style={{ width: '10%' }}>Date Start</div>
        <div style={{ width: '13%' }}>Number Of Tickets</div>
        <div style={{ width: '13%' }}>Available Tickets</div>
        <div style={{ width: '10%' }}>Ticket Price</div>
        <div style={{ width: '10%' }}>Sold Tickets</div>
        <div style={{ width: '12.5%' }}>Action</div>
        <div style={{ width: '12%' }}>Zoom Link</div>
      </InvoiceHeader>

      {webinarsMenagement?.length === 0 ? (
        <HubLengthMessage>No Webinars</HubLengthMessage>
      ) : (
        webinarsMenagement?.map((inv: any, i: number) => {
          const isExpired = new Date(inv?.dateStart) < new Date();
          return (
            <AnimatedItem key={i} index={i}>
              <Invoices>
                <div style={{ width: '10%' }}>{inv?.name}</div>
                <div style={{ width: '10%' }}>
                  {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
                </div>
                <div style={{ width: '10%' }}>
                  {inv?.dateStart &&
                    moment.utc(inv?.dateStart).format('DD/MM/YY')}
                </div>
                <div style={{ width: '13%' }}>{inv?.numberOfTickets}</div>
                <div style={{ width: '13%' }}>{inv?.availableTickets}</div>
                <div style={{ width: '10%' }}>{inv?.ticketPrice}</div>
                <div
                  style={{
                    width: '10%',
                    cursor: inv?.soldTickets?.length > 0 ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    if (inv?.soldTickets?.length > 0) {
                      setIsTicketsModalOpen(!isTicketsModalOpen);
                      setSelectedWebinar(inv);
                    }
                  }}>
                  {inv?.soldTickets?.length}
                </div>

                <div style={{ width: '12.5%' }}>
                  {' '}
                  <Button
                    disabled={isExpired}
                    onClick={() => {
                      setIsEditModalOpen(!isEditModalOpen);
                      setSelectedWebinar(inv);
                    }}>
                    Edit Webinar
                  </Button>
                </div>
                <div style={{ width: '12%' }}>
                  <a href={inv?.zoomStartUrl} target='_blank' rel='noreferrer'>
                    <Button ml='10' disabled={!isJoinButtonEnabled(inv)}>
                      JOIN
                    </Button>
                  </a>
                </div>
              </Invoices>
            </AnimatedItem>
          );
        })
      )}

      <SidebarModal
        isOpen={isSideModalOpen}
        setOpen={setIsSideModalOpen}
        title={'Create new webinar'}
        sidebarWidth={'511px'}>
        <CreateWebinar setIsSideModalOpen={setIsSideModalOpen} />
      </SidebarModal>

      <SidebarModal
        isOpen={isEditModalOpen}
        setOpen={setIsEditModalOpen}
        title={'Edit webinar'}
        sidebarWidth={'511px'}>
        <EditWebinar
          webinar={selectedWebinar}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      </SidebarModal>

      <SidebarModal
        isOpen={isTicketsModalOpen}
        setOpen={setIsTicketsModalOpen}
        title={'Sold tickets'}
        sidebarWidth={'600px'}>
        <SoldTickets
          setIsTicketModalOpen={setIsTicketsModalOpen}
          tickets={selectedWebinar?.soldTickets}
        />
      </SidebarModal>

      {/* <SidebarModal
        isOpen={isTicketsModalOpen}
        setOpen={setIsTicketsModalOpen}
        title={'Sold Tickets'}
        sidebarWidth={'511px'}>
        <SoldTickets
          soldTickets={soldTickets}
          setIsTicketsModalOpen={setIsTicketsModalOpen}
        />
      </SidebarModal> */}
    </AnimatedDashboard>
  );
};
